import { useCallback } from 'react';
import { useSetAtom } from 'jotai';

import { touchedAtom } from './atoms';

export const useTouchActionPlan = () => {
  const setTouched = useSetAtom(touchedAtom);

  return {
    setTouched,
    touchActionPlan: useCallback(() => setTouched(true), [setTouched]),
    resetTouched: useCallback(() => setTouched(false), [setTouched]),
  };
};
